export const routerPath = {
  HOME: "/",
  IMAGE_CREATOR: "image-creator",
  VERIFY_SOCIAL_AUTH: "verify-social-auth",
  PROFILE: "profile",
  Terms: "terms",
  Privacy: "privacy",
  AutoLogin: "auto-login",
};
